// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateCommitmentModalProjectItemQueryVariables = Types.Exact<{
  filter: Types.ProjectItemFilter;
}>;


export type CreateCommitmentModalProjectItemQuery = { __typename?: 'Query', projectItems: Array<{ __typename?: 'ProjectItem', id: string, protoCommitmentLineItemToBuyout?: { __typename?: 'ProtoCommitmentLineItemToBuyout', quantity?: number | null | undefined, costChangeInCents?: number | null | undefined } | null | undefined }> };

export type CreateCommitmentModal_ProjectItemFragment = { __typename?: 'ProjectItem', id: string, protoCommitmentLineItemToBuyout?: { __typename?: 'ProtoCommitmentLineItemToBuyout', quantity?: number | null | undefined, costChangeInCents?: number | null | undefined } | null | undefined };

export const CreateCommitmentModal_ProjectItemFragmentDoc = gql`
    fragment CreateCommitmentModal_ProjectItem on ProjectItem {
  id
  protoCommitmentLineItemToBuyout {
    quantity
    costChangeInCents
  }
}
    `;
export const CreateCommitmentModalProjectItemDocument = gql`
    query CreateCommitmentModalProjectItem($filter: ProjectItemFilter!) {
  projectItems(filter: $filter) {
    ...CreateCommitmentModal_ProjectItem
  }
}
    ${CreateCommitmentModal_ProjectItemFragmentDoc}`;

/**
 * __useCreateCommitmentModalProjectItemQuery__
 *
 * To run a query within a React component, call `useCreateCommitmentModalProjectItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCommitmentModalProjectItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCommitmentModalProjectItemQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreateCommitmentModalProjectItemQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateCommitmentModalProjectItemQuery, CreateCommitmentModalProjectItemQueryVariables> & ({ variables: CreateCommitmentModalProjectItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateCommitmentModalProjectItemQuery, CreateCommitmentModalProjectItemQueryVariables>(CreateCommitmentModalProjectItemDocument, options);
      }
export function useCreateCommitmentModalProjectItemLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateCommitmentModalProjectItemQuery, CreateCommitmentModalProjectItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateCommitmentModalProjectItemQuery, CreateCommitmentModalProjectItemQueryVariables>(CreateCommitmentModalProjectItemDocument, options);
        }
export function useCreateCommitmentModalProjectItemSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateCommitmentModalProjectItemQuery, CreateCommitmentModalProjectItemQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateCommitmentModalProjectItemQuery, CreateCommitmentModalProjectItemQueryVariables>(CreateCommitmentModalProjectItemDocument, options);
        }
export type CreateCommitmentModalProjectItemQueryHookResult = ReturnType<typeof useCreateCommitmentModalProjectItemQuery>;
export type CreateCommitmentModalProjectItemLazyQueryHookResult = ReturnType<typeof useCreateCommitmentModalProjectItemLazyQuery>;
export type CreateCommitmentModalProjectItemSuspenseQueryHookResult = ReturnType<typeof useCreateCommitmentModalProjectItemSuspenseQuery>;
export type CreateCommitmentModalProjectItemQueryResult = Apollo.QueryResult<CreateCommitmentModalProjectItemQuery, CreateCommitmentModalProjectItemQueryVariables>;